import AbstractRow from "./AbstractRow.js";

/**
 * Spacer rows displays empty rows.
 *
 * @param {boolean} [spec.horizontalLine = false] - Whether the spacer displays
 * an horizontal line.
 * @param {boolean} [spec.short = true] - Whether the spacer row
 * has a short or long row height.
 */
class SpacerRow extends AbstractRow {
	constructor({ horizontalLine = false, short = true } = {}) {
		super(...arguments);
		this._horizontalLine = horizontalLine;
		this._short = short;
	}

	getTitle() {
		return "Spacer";
	}

	canBeReferenced() {
		return false;
	}

	canBeUsedInFormulas() {
		return false;
	}

	canBeCalculated() {
		return false;
	}

	isHorizontalLine() {
		return this._horizontalLine;
	}

	isShort() {
		return this._short;
	}

	accept(visitor) {
		return visitor.visitSpacerRow(this);
	}

	serializedProperties() {
		return {
			rowType: this.getType(),
			horizontalLine: this.isHorizontalLine(),
			short: this.isShort(),
		};
	}

	static getType() {
		return "SpacerRow";
	}
}

export default SpacerRow;
